<template>
  <a
    :href="result.pagePath"
    class="row rounded overflow-hidden mx-0 mb-2 search-result"
  >
    <div class="col-auto bg-literature p-1 text-center side-icons">
      <FontAwesomeIcon :icon="icons.faBookOpen" class="d-block fa-fw" />
      <SearchResultScore :result="result" />
    </div>
    <div class="col p-3">
      <h3 class="h4 mb-1">
        <span class="text-primary">
          {{ result.title }}
        </span>
      </h3>
      <div class="row specs mt-3">
        <div v-if="customContent.revisionLevel" class="col pt-2 pr-2">
          <span class="line-1">REV</span>
          <span class="line-2">{{ customContent.revisionLevel }}</span>
        </div>
        <div v-if="customContent.revisionDate" class="col pt-2 pr-2">
          <span class="line-1">DATE</span>
          <span class="line-2">{{ revisionDate }}</span>
        </div>
        <div v-if="customContent.code" class="col pt-2 pr-2">
          <span class="line-1">CODE</span>
          <span class="line-2">{{ customContent.code }}</span>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import { faBookOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createNamespacedHelpers } from 'vuex';

import { formatDate } from '@/src/utilities/formatters';

import SearchResultScore from './SearchResultScore.vue';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'LiteratureResult',

  components: {
    FontAwesomeIcon,
    SearchResultScore,
  },

  props: {
    /** @type {import('vue').PropOptions<import('../store/state').SearchResult>} */
    result: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['culture']),

    /** @returns {{ faBookOpen: import('@fortawesome/fontawesome-common-types').IconDefinition }} */
    icons() {
      return { faBookOpen };
    },

    /** @returns {{ code: string, revisionDate: string, revisionLevel: string }} */
    customContent() {
      return this.result.customContent
        ? JSON.parse(this.result.customContent)
        : { code: '', revisionDate: '', revisionLevel: '' };
    },

    /** @returns {string} */
    revisionDate() {
      return formatDate(this.customContent.revisionDate, this.culture);
    },
  },
};
</script>
